export enum ECargoTransporterType {    
    None,
    MultiCargoTransporter,
    CargoTransporter
}